module.exports = __webpack_public_path__ + "static/media/galerija_2023 (10).d33cd033.png";